import r, { useEffect as u } from "react";
import { useProvideAuth as f, authContext as d } from "../../hooks/useAuth.js";
import { MagicLinkDetection as l } from "../MagicLinkDetection/MagicLinkDetection.js";
function n({
  children: o,
  token: i,
  scope: c,
  portalId: m,
  onAuthChange: t,
  onMagicAuth: s
}) {
  const e = f(c, m, i);
  return u(() => {
    e.isResolved && (t == null || t(e.customer, e.token));
  }, [e.isResolved, e.customer]), /* @__PURE__ */ r.createElement(d.Provider, { value: e }, o, /* @__PURE__ */ r.createElement(l, { onMagicAuth: s }));
}
export {
  n as AuthProvider
};
//# sourceMappingURL=AuthProvider.js.map
